import { HTTP_METHODS } from '@/utils/constants/httpMethods'

export const OFFLINE_ORDER_CONFIG = {
  OFFLINE_ORDER: (queryParams) => ({
    endPoint: 'orders?orderType=OFFLINE&' + queryParams,
    baseUrlKey: 'omsApiUrl', // Dynamically use OMS_API_URL
    method: HTTP_METHODS.POST,
  }),
  OFFLINE_ORDER_CSV_DOWNLOAD: (queryParams) => ({
    endPoint: 'orders/download?' + queryParams,
    method: HTTP_METHODS.POST,
    baseUrlKey: 'omsApiUrl', // Dynamically use OMS_API_URL
  }),
}